const OvalDiamond = ({ ...props }) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      xmlSpace="preserve"
      fill="currentColor"
      {...props}
    >
      <path
        d="M73.07,17.51C67.25,8.41,59.05,3.4,50,3.4S32.75,8.41,26.93,17.51C21.43,26.08,18.4,37.62,18.4,50
	s3.03,23.92,8.53,32.49C32.75,91.59,40.95,96.6,50,96.6s17.25-5.01,23.07-14.11c5.5-8.58,8.53-20.12,8.53-32.49
	S78.57,26.08,73.07,17.51z M59.09,82.41l-7.98-6.3l10.08-5.04L59.09,82.41z M50,95.01l-8.67-11.4L50,76.76l8.67,6.84L50,95.01z
	 M40.91,82.41l-2.1-11.34l10.08,5.04L40.91,82.41z M40.91,17.59l7.98,6.3l-10.08,5.04L40.91,17.59z M50,4.99l8.67,11.4L50,23.24
	l-8.67-6.84L50,4.99z M59.09,17.59l2.1,11.34l-10.08-5.04L59.09,17.59z M50,75.33l-11.5-5.75L32.63,50l5.87-19.58L50,24.67
	l11.5,5.75L67.37,50L61.5,69.58L50,75.33z M31.97,48.01l-3.75-11.25l8.75-5.42L31.97,48.01z M31.97,51.99l5,16.67l-8.75-5.42
	L31.97,51.99z M68.03,51.99l3.75,11.25l-8.75,5.42L68.03,51.99z M68.03,48.01l-5-16.67l8.75,5.42L68.03,48.01z M71.9,35.43
	l-9.36-5.8l-2.31-12.45l11.73,1.19L71.9,35.43z M37.46,29.63l-9.36,5.8l-0.06-17.05l11.73-1.19L37.46,29.63z M27.33,37.89L31.37,50
	l-4.04,12.11L19.71,50L27.33,37.89z M28.1,64.57l9.36,5.8l2.31,12.45l-11.73-1.19L28.1,64.57z M62.54,70.37l9.36-5.8l0.06,17.05
	l-11.73,1.19L62.54,70.37z M72.67,62.11L68.63,50l4.04-12.11L80.29,50L72.67,62.11z M73.1,36.33l0.06-16.35
	c4.38,7.65,6.91,17.41,7.21,27.9L73.1,36.33z M71.36,17.1l-11.54-1.17l-8.59-11.3C59.02,5.05,66.09,9.44,71.36,17.1z M48.77,4.63
	l-8.59,11.3L28.64,17.1C33.91,9.44,40.98,5.05,48.77,4.63z M26.84,19.97l0.06,16.35l-7.27,11.55
	C19.93,37.38,22.46,27.63,26.84,19.97z M26.9,63.67l-0.06,16.35c-4.38-7.65-6.91-17.41-7.21-27.9L26.9,63.67z M28.64,82.9
	l11.54,1.17l8.59,11.3C40.98,94.95,33.91,90.56,28.64,82.9z M51.23,95.37l8.59-11.3l11.54-1.17C66.09,90.56,59.02,94.95,51.23,95.37
	z M73.16,80.03L73.1,63.67l7.27-11.55C80.07,62.62,77.54,72.37,73.16,80.03z"
      />
    </svg>
  )
}

export default OvalDiamond
